"use strict";
/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoIcon = void 0;
var react_1 = __importStar(require("react"));
var useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));
var Icon_1 = require("./Icon");
exports.GoIcon = (0, react_1.forwardRef)(function GoIcon(_a, ref) {
    var bgColor = _a.bgColor, textColor = _a.textColor, rest = __rest(_a, ["bgColor", "textColor"]);
    var theme = (0, useTheme_1.default)();
    bgColor = bgColor || theme.go.schemes.colors.system.IconMain;
    textColor = textColor || theme.go.schemes.colors.system.BgMain;
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 299 276", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest),
        react_1.default.createElement("path", { d: "M95.3694 0H202.525C228.111 0.00266586 252.648 10.1645 270.74 28.2506C288.832 46.3368 298.998 70.866 299 96.4437V179.566C299 192.231 296.505 204.772 291.656 216.472C286.808 228.173 279.701 238.804 270.743 247.759C261.784 256.714 251.149 263.817 239.444 268.662C227.739 273.508 215.194 276.001 202.525 276H96.4756C83.8068 276.001 71.2618 273.508 59.5569 268.662C47.852 263.817 37.2166 256.714 28.2579 247.759C19.2992 238.804 12.1928 228.173 7.3443 216.472C2.49584 204.772 0.000366142 192.231 0.000366211 179.566V96.4437C0.000366211 43.1699 42.0782 0 95.3694 0Z", fill: bgColor }),
        react_1.default.createElement("path", { d: "M121.611 156.051V151.366H93.3909V130.515H148.414V155.317C148.414 194.355 129.765 217.036 94.4968 217.036C58.1231 217.036 37.0005 188.383 37.0005 137.864C37.0005 88.6019 60.0533 58.4413 102.349 58.4413C118.324 58.4413 132.107 62.6738 139.637 68.1832V89.6475C128.818 82.945 116.362 79.3519 103.635 79.2622C75.8978 79.2622 64.1351 98.0925 64.1351 137.864C64.1351 176.44 73.877 196.175 94.9995 196.175C115.177 196.275 121.611 180.662 121.611 156.051Z", fill: textColor }),
        react_1.default.createElement("path", { d: "M262.522 158.987C262.522 196.466 242.314 217.126 213.259 217.126C184.205 217.126 163.997 196.466 163.997 159.268C163.997 121.789 184.205 101.129 213.259 101.129C242.314 101.129 262.522 121.698 262.522 158.987ZM235.236 158.987C235.236 133.27 227.887 121.98 213.289 121.98C198.692 121.98 191.333 133.27 191.333 159.268C191.333 184.985 198.682 196.285 213.289 196.285C227.897 196.285 235.236 184.895 235.236 158.987Z", fill: textColor })));
});
